import { InputWithLabel } from '@adotel/components'
import '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { useEffect, useState } from 'react'

import PermissionActiveTabs from '../../components/PermissionActiveTabs'
import { getTranslate } from '../../localization'
import { Permission, PermissionAction, SubPermission } from '../../types/role'
import useStyles from './styles/filters.styles'

interface FiltersProps {
  temporaryPermissions: Permission[]
  setfilteredPermissions: React.Dispatch<React.SetStateAction<Permission[]>>
}

const Filters: React.FC<FiltersProps> = ({
  temporaryPermissions,
  setfilteredPermissions
}) => {
  const classes = useStyles()
  const [searchInputVal, setSearchInputVal] = useState('')
  const [activeStatus, setaAtiveStatus] = useState('All')

  useEffect(() => {
    const searchLower = searchInputVal?.toLowerCase() ?? ''
    const searchFilteredPermissions = temporaryPermissions
      .map((perm) => {
        // Filter subPermissions by search input
        const matchedSubPermissions = perm.subPermissions.filter((sub) =>
          sub.name.toLowerCase().includes(searchLower)
        )

        // Keep top-level permission if permissionName matches or has matching subPermissions
        const permissionMatches = perm.permissionName
          .toLowerCase()
          .includes(searchLower)

        if (!permissionMatches && matchedSubPermissions.length === 0) {
          return null // skip this permission entirely
        }

        return {
          ...perm,
          subPermissions: matchedSubPermissions
        }
      })
      .filter((p): p is Permission => Boolean(p)) // remove nulls
      .map((perm) => {
        if (activeStatus === 'All') return perm

        const filteredSubPermissions = perm.subPermissions
          .map((sub) => {
            let filteredActions: PermissionAction[] = []

            switch (activeStatus) {
              case 'Not-Selected':
                if (sub.actions.some((act) => !act.selected)) {
                  filteredActions = sub.actions
                }
                break
              case 'Role-Based': {
                const hasRoleBased = sub.actions.some(
                  (act) => act.permissionSource === 'RoleBased'
                )

                if (!hasRoleBased) return null

                filteredActions = sub.actions.map((act) => ({
                  ...act,
                  disabled: act.permissionSource !== 'RoleBased'
                }))
                break
              }
              case 'User-Based': {
                const hasUserBased = sub.actions.some(
                  (act) => act.permissionSource === 'UserBased'
                )

                if (!hasUserBased) return null

                filteredActions = sub.actions.map((act) => ({
                  ...act,
                  disabled: act.permissionSource !== 'UserBased'
                }))
                break
              }
            }

            if (filteredActions.length === 0) return null

            return {
              ...sub,
              actions: filteredActions
            }
          })
          .filter((s): s is SubPermission => Boolean(s))

        if (filteredSubPermissions.length === 0) return null

        return {
          ...perm,
          subPermissions: filteredSubPermissions
        }
      })
      .filter((p): p is Permission => Boolean(p))

    setfilteredPermissions(searchFilteredPermissions)
  }, [searchInputVal, activeStatus, temporaryPermissions])

  return (
    <div className={classes.root}>
      <div className={classes.row2}>
        <InputWithLabel
          placeholder={getTranslate('Search in role permissions')}
          noHelperText
          fullWidth
          startIcon={<SearchIcon />}
          inputSize="small"
          value={searchInputVal}
          onChange={(event) => setSearchInputVal(event.currentTarget.value)}
        />
      </div>
      <PermissionActiveTabs
        title={getTranslate('Permission Status')}
        value={activeStatus}
        setValue={setaAtiveStatus}
      />
    </div>
  )
}

export default Filters
